module.exports = __webpack_public_path__ + "img/company-wechat.b194e8f2.jpg";